export default __webpack_public_path__ + "static/media/Viet_ComparePricing_Homepage.22de1bef.webp";